import events from './events';

export default function bus(riot) {
  const b = riot.observable();

  b.EVENTS = events;

  return b;
}
